// extracted by mini-css-extract-plugin
export default {"TableauBootstrap":"TableauComposante_TableauBootstrap__78NqE","btn_stylo":"TableauComposante_btn_stylo__zS-W8"};